export default "__VITE_ASSET__BV9h6Z46__"